"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Spin = _interopRequireDefault(require("./Spin"));
var _getBordersStyles = _interopRequireDefault(require("../../utils/getBordersStyles"));
var _UIElementSizesEnum = require("../ts/enums/UIElementSizesEnum");
var _templateObject;
const _excluded = ["children", "htmlType", "disabled", "outlined", "type", "loading"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var HtmlType = /*#__PURE__*/function (HtmlType) {
  HtmlType["button"] = "button";
  HtmlType["submit"] = "submit";
  HtmlType["reset"] = "reset";
  return HtmlType;
}(HtmlType || {});
var ButtonType = /*#__PURE__*/function (ButtonType) {
  ButtonType["primary"] = "primary";
  ButtonType["success"] = "success";
  ButtonType["error"] = "error";
  ButtonType["warning"] = "warning";
  ButtonType["ghost"] = "ghost";
  ButtonType["white"] = "white";
  ButtonType["link"] = "link";
  return ButtonType;
}(ButtonType || {});
const defaultProps = {
  type: ButtonType.primary,
  size: _UIElementSizesEnum.UIElementSizesEnum.Medium,
  htmlType: HtmlType.button,
  onClick() {},
  loading: false,
  width: '100%'
};
function Button(_ref) {
  let {
      children,
      htmlType,
      disabled,
      outlined,
      type,
      loading
    } = _ref,
    restOfProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("button", _extends({}, restOfProps, {
    type: htmlType,
    disabled: disabled || loading
  }), loading ? /*#__PURE__*/_react.default.createElement(_Spin.default, {
    type: outlined ? type : ButtonType.ghost,
    size: 20
  }) : children);
}
const WrapperButton = (0, _styled.default)(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0px 20px;\n    border-radius: 10px;\n    cursor: pointer;\n    border: none;\n    font-weight: bold;\n\n    margin: ", ";\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  ", "\n  }\n"])), _ref2 => {
  let {
    margin = '0px'
  } = _ref2;
  return margin;
}, _ref3 => {
  let {
    width
  } = _ref3;
  return width && "width: ".concat(width, ";");
}, _ref4 => {
  let {
    size
  } = _ref4;
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Small) return "\n        height: 35px;\n        font-size: 12px;\n        border-radius: 7px;\n\n        @media screen and (min-width: 768px) {\n          font-size: 14px;\n        }\n      ";
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Medium) return "\n        height: 44px;\n        font-size: 12px;\n        border-radius: 7px;\n\n        @media screen and (min-width: 768px) {\n          font-size: 14px;\n        }\n      ";
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Large) return "\n        height: 50px;\n        font-size: 18px;\n\n        @media screen and (min-width: 768px) {\n          font-size: 20px;\n        }\n      ";
}, _ref5 => {
  var _colors$MAIN;
  let {
    type,
    outlined,
    theme,
    margin = '5px 0',
    highlight
  } = _ref5;
  const {
    colors
  } = theme;
  let style = "\n      ".concat(!highlight ? '-webkit-tap-highlight-color: transparent;' : '', "\n    ");
  if (type === ButtonType.link) {
    style += "\n          color: ".concat(colors.MAIN.INFO, ";\n          background-color: ").concat(colors.NEUTRAL.TRANSPARENT, ";\n          font-weight: bold;\n          padding: 0px;\n          height: auto;\n          margin: ").concat(margin, ";\n        ");
    return style;
  }
  if (type === ButtonType.ghost) {
    style += "\n        color: ".concat(colors.FONT.HELPER, ";      \n        background-color: ").concat(outlined ? colors.NEUTRAL.TRANSPARENT : colors.NEUTRAL.SELECTED, ";\n        ").concat((0, _getBordersStyles.default)(1, outlined, colors.NEUTRAL.SELECTED), "\n      ");
    return style;
  }
  if (type === ButtonType.white) {
    style += "\n          background-color: ".concat(outlined ? colors.NEUTRAL.TRANSPARENT : colors.NEUTRAL.CARD, ";\n          color: ").concat(outlined ? colors.NEUTRAL.CARD : colors.FONT.TITLE, ";\n          font-weight: 700;\n          ").concat((0, _getBordersStyles.default)(1, outlined, colors.NEUTRAL.SELECTED), "\n        ");
    return style;
  }
  const mainColor = (_colors$MAIN = colors.MAIN) === null || _colors$MAIN === void 0 ? void 0 : _colors$MAIN[String(type).toUpperCase()];
  style += "\n        background-color: ".concat(outlined ? colors.NEUTRAL.TRANSPARENT : mainColor, ";\n        color: ").concat(outlined ? mainColor : colors.NEUTRAL.BACKGROUND, ";\n        ").concat((0, _getBordersStyles.default)(1, outlined, mainColor), "\n      ");
  return style;
}, _ref6 => {
  let {
    disabled,
    type,
    theme
  } = _ref6;
  const {
    colors
  } = theme;
  if (disabled && type === ButtonType.link) {
    return "\n        color: ".concat(colors.FONT.HELPER, ";\n      ");
  }
  if (disabled) return "opacity: 0.85;";
}, _ref7 => {
  let {
    styles
  } = _ref7;
  return styles;
});
WrapperButton.defaultProps = defaultProps;
var _default = exports.default = WrapperButton;